export default __webpack_public_path__ + "12dd532e5b196a84fdf12d83ca8fd9ed.png";